import { frontendURL } from '../../../../helper/URLHelper';
import { hasPermissions } from '../../../../helper/permissionsHelper';
import {
  FRANCHISE_EDIT_PERMISSIONS,
  FRANCHISE_MANAGE_PERMISSIONS,
} from '../../../../constants/permissions';

// Espelho de FranchisePolicy::Scope: administrador, franchise_edit e franchise_manage
// enxergam todas as franquias da conta; quem tem só franchise_view enxerga apenas aquelas
// em que é o responsável financeiro. Sem isso o menu diria "Todos os Franqueados" para
// quem só vê o próprio, e "Faturamento" para quem só vê a própria conta a pagar.
const seesEveryFranchise = (context = {}) => {
  const { userPermissions, role } = context;

  // Chamador que não sabe as permissões (o layout da central de ajuda) não deve fazer o
  // menu afirmar "Meus" — na dúvida fica o rótulo geral, que é o comportamento anterior.
  if (!role && !userPermissions) return true;

  return (
    role === 'administrator' ||
    hasPermissions(
      [FRANCHISE_EDIT_PERMISSIONS, FRANCHISE_MANAGE_PERMISSIONS],
      userPermissions || []
    )
  );
};

const franchises = (accountId, context = {}) => {
  const seesAll = seesEveryFranchise(context);

  return {
    parentNav: 'franchises',
    routes: [
      'franchises_dashboard',
      'franchise_profile_dashboard',
      'franchise_financial_dashboard',
      'franchises_billing',
    ],
    menuItems: [
      {
        icon: 'building-bank',
        label: seesAll ? 'ALL_FRANCHISES' : 'MY_FRANCHISES',
        key: 'all_franchises',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/franchises`),
        toStateName: 'franchises_dashboard',
        isActive: route => route.name === 'franchises_dashboard',
      },
      {
        icon: 'wallet',
        // MY_BILLING é chave NOVA de propósito: SIDEBAR.BILLING também nomeia o
        // Faturamento da conta, em Configurações. Editar aquela chave renomearia a tela
        // errada.
        label: seesAll ? 'BILLING' : 'MY_BILLING',
        key: 'franchises_billing',
        hasSubMenu: false,
        toState: frontendURL(`accounts/${accountId}/franchises/billing`),
        toStateName: 'franchises_billing',
        isActive: route => route.name === 'franchises_billing',
      },
    ],
  };
};

export default franchises;
